import React from 'react'
import { Box, Typography } from '@mui/material'

// Shared title block for list-style pages (Favorites, Appointments, ...).
// Keeps typography/spacing identical everywhere it's used so pages never
// drift apart visually the way Favorites and Appointments once did.
export default function PageHeader({ title, subtitle, action }) {
  return (
    <Box sx={{
      bgcolor: 'background.paper',
      // Keeps the theme's normal 28px top padding, plus whatever the notch/
      // Dynamic Island needs on real devices (0 on web/Android browsers).
      pt: (t) => `calc(${t.spacing(3.5)} + env(safe-area-inset-top, 0px))`,
      pb: 2,
      px: 2.5,
      flexShrink: 0,
      borderBottom: '1px solid',
      borderColor: 'divider',
    }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1 }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h6" sx={{ fontWeight: 800, letterSpacing: '-0.2px' }} noWrap>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {action}
      </Box>
    </Box>
  )
}
